import { useQuery } from '@tanstack/react-query';
import { ALL_BRANCHES } from 'src/context/types';
import { useTenantContext } from 'src/context/useTenantContext';
import { orgRestaurantBranches } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useBranches = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery({
    queryKey: [QUERIES.BRANCHES, orgSlug, restaurantId],
    enabled: Boolean(restaurantId),
    queryFn: () => orgRestaurantBranches({ orgSlug, restaurantId }),
  });
};

export const useCurrentRestaurantBranch = () => {
  const { branchId } = useTenantContext();
  const { data } = useBranches();
  if (!branchId || branchId === ALL_BRANCHES) {
    return null;
  }
  return data?.data?.find((item) => item.id === branchId) ?? null;
};
